import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  subscribeOrder,
  getMerchant,
  updateEstimatedTimes,
  subscribeOrdersByStatus,
  getOrder,
  searchOrders,
  putOrder,
  selectOrder,
  searchOrdersByStatus,
  searchOrdersByHours,
  updateDeliveryPersonally,
} from '../actions';
import { getOrdersBySearch } from '../reducers/orders';

import Home from '../screens/Home';

const mapStateToProps = ({ order, orders, merchant }) => ({
  merchantIsFetching: merchant.isFetching,
  merchantIsUpdating: merchant.isUpdating,
  merchant: merchant.merchant,
  orders: orders.list,
  ordersLoaded: orders.loaded,
  ordersIsFetching: orders.isFetching,
  ordersError: orders.error,
  isFiltered: orders.searchStatus.id !== 0,
  search: orders.search,
  ordersFiltered: getOrdersBySearch(orders.search, orders.list), //eslint-disable-line
  searchStatus: orders.searchStatus,
  searchHours: orders.searchHours,
  order: order.data,
  idOrderSelected: order.idOrderSelected,
  orderIsFetching: order.isFetching,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      subscribeOrder,
      subscribeOrdersByStatus,
      getOrder,
      searchOrders,
      putOrder,
      getMerchant,
      updateEstimatedTimes,
      selectOrder,
      searchOrdersByStatus,
      searchOrdersByHours,
      updateDeliveryPersonally,
    },
    dispatch
  );

const HomeContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);

export default HomeContainer;



// WEBPACK FOOTER //
// ./src/containers/HomeContainer.js